import { onActivated, onBeforeUnmount, onDeactivated, onMounted } from 'vue'
import { coalescedRefresh } from '../api/coalescedRefresh.js'
import { subscribeProjectChange } from '../utils/projectRefresh.js'

// The workspace remounts the cache when tenant/project changes.
export function useProjectRefresh(scope, refresh, pause = () => {}) {
  let active = false
  let timer
  const queue = coalescedRefresh(refresh)
  const visible = () => active && document.visibilityState !== 'hidden'
  const sync = () => { if (visible()) void queue.run().catch(() => {}) }
  const visibility = () => { if (visible()) sync(); else pause() }
  const unsubscribe = subscribeProjectChange(scope, sync)
  function activate() {
    if (active) return
    active = true
    sync()
    timer = window.setInterval(sync, 20_000)
  }
  function deactivate() {
    active = false
    clearInterval(timer)
    pause()
  }
  onMounted(() => {
    window.addEventListener('focus', sync)
    window.addEventListener('online', sync)
    document.addEventListener('visibilitychange', visibility)
    activate()
  })
  onActivated(activate)
  onDeactivated(deactivate)
  onBeforeUnmount(() => {
    deactivate()
    unsubscribe()
    queue.stop()
    window.removeEventListener('focus', sync)
    window.removeEventListener('online', sync)
    document.removeEventListener('visibilitychange', visibility)
  })
  return { visible, sync }
}
